import styled from "styled-components";

export const SampleWrapper = styled.div`
  border: 1px dashed white;
  padding: 6px 12px;
  margin-top: 6px;
`;
